import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Digiteal\RegisterCompanyToPeppolController::__invoke
* @see app/Http/Controllers/Digiteal/RegisterCompanyToPeppolController.php
* @route '/api/company/{company}/peppol/register'
*/
const RegisterCompanyToPeppolController = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: RegisterCompanyToPeppolController.url(args, options),
    method: 'post',
})

RegisterCompanyToPeppolController.definition = {
    methods: ["post"],
    url: '/api/company/{company}/peppol/register',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Digiteal\RegisterCompanyToPeppolController::__invoke
* @see app/Http/Controllers/Digiteal/RegisterCompanyToPeppolController.php
* @route '/api/company/{company}/peppol/register'
*/
RegisterCompanyToPeppolController.url = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { company: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { company: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            company: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        company: typeof args.company === 'object'
        ? args.company.id
        : args.company,
    }

    return RegisterCompanyToPeppolController.definition.url
            .replace('{company}', parsedArgs.company.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Digiteal\RegisterCompanyToPeppolController::__invoke
* @see app/Http/Controllers/Digiteal/RegisterCompanyToPeppolController.php
* @route '/api/company/{company}/peppol/register'
*/
RegisterCompanyToPeppolController.post = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: RegisterCompanyToPeppolController.url(args, options),
    method: 'post',
})

export default RegisterCompanyToPeppolController